"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareSheet = exports.toShareDestination = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const metrics_1 = require("@snapchat/content-platform-www/generated-src/snapchat/web/stories/metrics");
const react_intl_1 = require("react-intl");
const ShareSheet_module_css_1 = __importDefault(require("./ShareSheet.module.css"));
const event_1 = require("@snapchat/ts-protos/event");
const ShareBar_1 = require("../../ShareBar");
const offPlatformShareEnums_1 = require("../../offPlatformShareEnums");
const shareDestinations_1 = require("../../shareDestinations");
const sharingUtils_1 = require("../../sharingUtils");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const device_detection_1 = require("../../device-detection");
const web_env_1 = require("@snapchat/web-env");
const copyText = (text) => {
    const navigatorObj = (0, web_env_1.getNavigator)();
    if (navigatorObj?.clipboard) {
        void navigatorObj.clipboard.writeText(text);
    }
    else {
        console.error("Clipboard is undefined");
    }
};
/**
 * converts WebShareDestination enum to corresponding ShareDestination enum
 */
function toShareDestination(shareDestination) {
    switch (shareDestination) {
        case event_1.WebShareDestination.WEB_SHARE_DESTINATION_UNKNOWN:
            return metrics_1.ShareDestination.WEB_SHARE_DESTINATION_UNKNOWN;
        case event_1.WebShareDestination.WEB_SHARE_API:
            return metrics_1.ShareDestination.WEB_SHARE_API;
        case event_1.WebShareDestination.COPY_LINK:
            return metrics_1.ShareDestination.COPY_LINK;
        case event_1.WebShareDestination.MESSAGES:
            return metrics_1.ShareDestination.MESSAGES;
        case event_1.WebShareDestination.FACEBOOK:
            return metrics_1.ShareDestination.FACEBOOK;
        case event_1.WebShareDestination.MESSENGER:
            return metrics_1.ShareDestination.MESSENGER;
        case event_1.WebShareDestination.TIKTOK:
            return metrics_1.ShareDestination.TIKTOK;
        case event_1.WebShareDestination.TWITTER:
            return metrics_1.ShareDestination.TWITTER;
        case event_1.WebShareDestination.WHATSAPP:
            return metrics_1.ShareDestination.WHATSAPP;
        case event_1.WebShareDestination.INSTAGRAM:
            return metrics_1.ShareDestination.INSTAGRAM;
        case event_1.WebShareDestination.REDDIT:
            return metrics_1.ShareDestination.REDDIT;
        case event_1.WebShareDestination.PINTEREST:
            return metrics_1.ShareDestination.PINTEREST;
        case event_1.WebShareDestination.MAIL:
            return metrics_1.ShareDestination.MAIL;
        case event_1.WebShareDestination.WEB_SHARE_TO_SNAPCHAT:
            return metrics_1.ShareDestination.WEB_SHARE_TO_SNAPCHAT;
        default:
            return metrics_1.ShareDestination.UNRECOGNIZED;
    }
}
exports.toShareDestination = toShareDestination;
/**
 *
 */
function ShareSheet({ pageName, pageType, title, url, onClose, sessionOpenTime, incrementCounter, withEmbed, }) {
    const intl = (0, react_intl_1.useIntl)();
    const shareDefaultTitle = intl.formatMessage({
        id: "A9tP6F",
        description: "ShareSheet default title",
        defaultMessage: "Share",
    });
    const [displayTooltip, setDisplayTooltip] = (0, react_1.useState)(false);
    const timerRef = (0, react_1.useRef)();
    const webClientId = (0, web_sc_cookies_1.useGetWebClientId)() || "";
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, no-restricted-globals
    const navigatorShare = (0, web_env_1.getWindow)()?.navigator?.share;
    // @ts-ignore
    const shareDestinations = 
    // @ts-ignore:next-line
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    navigatorShare
        ? (0, shareDestinations_1.defaultShareSheetShareDestinations)(withEmbed)
        : (0, shareDestinations_1.fallbackShareSheetShareDestinations)(withEmbed);
    const report = (0, react_1.useCallback)((shareStatus, destinationSelected, deepLinkUrl) => {
        const sessionTimeSec = sessionOpenTime === 0 ? 0 : parseFloat(((Date.now() - sessionOpenTime) / 1000).toFixed(0));
        const shareSheetDestinations = shareDestinations.map((shareDestination) => (0, metrics_1.shareDestinationToJSON)(toShareDestination(shareDestination.shareDestination)));
        const shareProps = {
            sessionTimeSec,
            shareSource: event_1.WebShareSource.WEB_SHARE_SHEET,
            webDestinationsAvailable: shareSheetDestinations.join(","),
            webDestinationsSeen: shareSheetDestinations.join(","),
            destinationSelected,
            deepLinkUrl,
            // eslint-disable-next-line no-restricted-globals
            webPageUrl: (0, web_env_1.getWindow)()?.location.href,
            shareStatus,
            pageType,
            webClientId,
        };
        (0, web_blizzard_reporting_1.reportWebPageShare)(shareProps);
    }, [pageType, sessionOpenTime, shareDestinations, webClientId]);
    const handleClick = (selectedDestination) => () => {
        const id = selectedDestination.id;
        const webShareUrl = (0, sharingUtils_1.prepareUrlForSharing)(url, (0, device_detection_1.getMobileDeviceType)());
        let shareStatus = event_1.WebShareStatus.WEB_SHARE_STATUS_UNKNOWN;
        if (selectedDestination.mobileTooltipComponent) {
            setDisplayTooltip(true);
            timerRef.current = (0, web_env_1.getWindow)()?.setTimeout(() => {
                setDisplayTooltip(false);
            }, 3000);
        }
        const reportAndClose = () => {
            onClose();
            // @ts-ignore
            report(shareStatus, selectedDestination.shareDestination, webShareUrl);
        };
        const handleCopyLink = () => {
            copyText(webShareUrl);
            void incrementCounter(`${pageName}.Mobile.Share.${id}.Success`);
            shareStatus = event_1.WebShareStatus.WEB_SHARE_STATUS_SUCCESS;
            // Don't close the ShareSheet after CopyUrl
            // @ts-ignore
            report(shareStatus, selectedDestination.shareDestination, webShareUrl);
        };
        const handleShare = () => {
            (0, web_env_1.getNavigator)()
                ?.share({
                url: webShareUrl,
            })
                .then(() => {
                shareStatus = event_1.WebShareStatus.WEB_SHARE_STATUS_SUCCESS;
                void incrementCounter(`${pageName}.Mobile.Share.${id}.Success`);
            })
                .catch((error) => {
                console.error("Error sharing", error);
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                if (error.name === "AbortError") {
                    shareStatus = event_1.WebShareStatus.WEB_SHARE_STATUS_ABORTED;
                    void incrementCounter(`${pageName}.Mobile.Share.${id}.Aborted`);
                }
                else {
                    shareStatus = event_1.WebShareStatus.WEB_SHARE_STATUS_FAILED;
                    void incrementCounter(`${pageName}.Mobile.Share.${id}.Failure`);
                }
            })
                .then(reportAndClose, reportAndClose);
        };
        const handleShareBaseUrl = (shareBaseUrl) => {
            const platformShareUrl = `${shareBaseUrl}${webShareUrl}`;
            (0, web_env_1.getWindow)()?.open(platformShareUrl, "_blank");
            shareStatus = event_1.WebShareStatus.WEB_SHARE_STATUS_SUCCESS;
            void incrementCounter(`${pageName}.Mobile.Share.${id}.Success`);
            reportAndClose();
        };
        if (id === offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.COPY_LINK) {
            handleCopyLink();
            // @ts-ignore:next-line
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        }
        else if ((0, web_env_1.getNavigator)()?.share) {
            handleShare();
        }
        else if (selectedDestination.shareBaseUrl) {
            // Let's use the shareBaseUrl when Web Share API is not available.
            handleShareBaseUrl(selectedDestination.shareBaseUrl);
        }
        else {
            // TODO: Report Share Status as Unavailable when web share api is not available on mobile.
            void incrementCounter(`${pageName}.Mobile.Share.Unavailable`);
            reportAndClose();
        }
    };
    const handleClose = (0, react_1.useCallback)(() => {
        // TODO - add a different ShareStatus for close instead of ABORTED.
        report(event_1.WebShareStatus.WEB_SHARE_STATUS_ABORTED, event_1.WebShareDestination.WEB_SHARE_DESTINATION_UNKNOWN, "");
        onClose();
    }, [report, onClose]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: ShareSheet_module_css_1.default.container, children: (0, jsx_runtime_1.jsxs)("div", { className: ShareSheet_module_css_1.default.body, "data-testid": "shareSheetContainer", children: [(0, jsx_runtime_1.jsx)("div", { className: ShareSheet_module_css_1.default.title, children: (0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H5", children: title || shareDefaultTitle }) }), (0, jsx_runtime_1.jsx)("div", { className: ShareSheet_module_css_1.default.closeButton, onClick: handleClose, "data-testid": "shareSheetCloseButton", children: (0, jsx_runtime_1.jsx)(web_core_ui_1.DownChevronIcon, { size: web_core_ui_1.Sizes.Medium, fill: "#53575B" }) }), (0, jsx_runtime_1.jsx)("div", { className: ShareSheet_module_css_1.default.mediaPlatforms, children: shareDestinations.map((shareDestination) => shareDestination.id === offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.EMBED ? ((0, jsx_runtime_1.jsxs)("div", { className: ShareSheet_module_css_1.default.embedWrapper, children: [(0, jsx_runtime_1.jsx)(ShareBar_1.EmbedSharing, { pageName: pageName, pageType: pageType, shareDestinations: shareDestinations, incrementCounter: incrementCounter, shareLink: url, title: title || "", isMobile: true }), (0, jsx_runtime_1.jsx)("div", { className: ShareSheet_module_css_1.default.iconHeadingText, children: shareDestination.title ? shareDestination.title : shareDestination.id })] }, shareDestination.id)) : ((0, jsx_runtime_1.jsx)("div", { "data-testid": "shareSheetIconStyle", children: (0, jsx_runtime_1.jsxs)("div", { className: ShareSheet_module_css_1.default.iconHeading, children: [(0, jsx_runtime_1.jsx)("div", { className: ShareSheet_module_css_1.default.icon, children: (0, jsx_runtime_1.jsx)(web_core_ui_1.IconButton, { onClick: handleClick(shareDestination), size: "MEDIUM", label: (0, ShareBar_1.getShareIconLabel)(shareDestination.id), children: (0, jsx_runtime_1.jsx)("div", { className: ShareSheet_module_css_1.default.iconWrapper, children: (0, jsx_runtime_1.jsx)(shareDestination.icon, {}) }) }) }), (0, jsx_runtime_1.jsx)("div", { className: ShareSheet_module_css_1.default.iconHeadingText, children: shareDestination.title ? shareDestination.title : shareDestination.id }), displayTooltip && shareDestination.mobileTooltipComponent && ((0, jsx_runtime_1.jsx)("div", { className: ShareSheet_module_css_1.default.tooltipContainer, children: (0, jsx_runtime_1.jsx)(shareDestination.mobileTooltipComponent, { intl: intl }) }))] }) }, shareDestination.id))) })] }) }) }));
}
exports.ShareSheet = ShareSheet;
//# sourceMappingURL=index.js.map